import { Box, Flex, Grid, Spinner, Tooltip } from '@chakra-ui/react';
import { useGameColorsProvider } from 'src/providers/Theme/gameColorsProvider';
import { BuyStages } from '../getGame';
import { disabledGames } from 'src';
import { useLocation } from 'react-router-dom';

const FirstTimeButton = ({
	label,
	number,
	disabled,
	loading,
	onClick,
}: {
	label: string;
	number: number;
	disabled: boolean;
	loading: boolean;
	onClick: () => any;
}) => {
	const { callToActionColor, callToActionTextColor } = useGameColorsProvider();

	return (
		<Flex
			background={callToActionColor}
			_hover={disabled || loading ? {} : { opacity: 0.7 }}
			opacity={disabled ? '0.6' : '1'}
			textTransform="uppercase"
			padding="7px"
			justifyContent="center"
			borderRadius="6px"
			onClick={disabled ? () => {} : onClick}
			cursor={disabled || loading ? 'default' : 'pointer'}
		>
			<Flex
				flexDir="column"
				alignItems="center"
			>
				<Box fontSize="9px">Step {number}</Box>
				<Box
					fontSize="12px"
					lineHeight="100%"
					fontWeight="bold"
				>
					{loading ? <Spinner boxSize="10px" /> : label}
				</Box>
			</Flex>
		</Flex>
	);
};

export const FirstTimeButtons = ({
	stage,
	handleBuy,
	handleApprove,
}: {
	stage: BuyStages;
	handleBuy: () => any;
	handleApprove: () => any;
}) => {
	const location = useLocation();

	const isDisabled = !!location.pathname?.toString()?.includes(disabledGames[0]);

	return (
		<Tooltip label={isDisabled ? 'You cannot buy this game anymore.' : ''}>
			<Grid
				gap="5px"
				templateColumns="1fr 1fr"
			>
				<FirstTimeButton
					label="APPROVE"
					number={1}
					disabled={stage != BuyStages.NOT_STARTED || isDisabled}
					loading={stage == BuyStages.APPROVING}
					onClick={handleApprove}
				/>
				<FirstTimeButton
					label="BUY"
					number={2}
					disabled={stage != BuyStages.APPROVED || isDisabled}
					loading={stage == BuyStages.BUYING}
					onClick={handleBuy}
				/>
			</Grid>
		</Tooltip>
	);
};
